import React, { useEffect, useRef } from "react";
import { useState } from "react";

import { Link } from "react-router-dom";

import { closeModal, ToastMain } from "../master/Master";
import Nav from "../master/NavBar";

import Swal from "sweetalert2";
import MocklHeader from "./MockHeader";

export default function Moketestdasbrd() {
    const [loading, setLoading] = useState(false);




    return (
        <>
            {loading && (
                <div
                    className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                    style={{ zIndex: 9999 }}
                >
                    <div className="sk-chase sk-primary display-1">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>
                </div>
            )}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <MocklHeader />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="card p-3 text-center">
                                            <div className="card-title">Total Mock Tests</div>
                                            <div className="card-body">40</div>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="card p-3 text-center">
                                            <div className="card-title">Students in Mock Test</div>
                                            <div className="card-body">120</div> {/* replace with actual number */}
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="card p-3 text-center">
                                            <div className="card-title">Total Pending Mock Tests</div>
                                            <div className="card-body">5</div> {/* example */}
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="card p-3 text-center">
                                            <div className="card-title">Total Number Mock Tests</div>
                                            <div className="card-body">15</div>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="card p-3 text-center">
                                            <div className="card-title">Upcoming Mock Tests</div>
                                            <div className="card-body">3</div>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="card p-3 text-center">
                                            <div className="card-title">Total Mock</div>
                                            <div className="card-body">60</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </>
    );
}
